module.exports = __webpack_public_path__ + "static/media/010book_in1.ec3fe1fa.png";